import { lightColorPalette } from '@linearb/linui-common';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const StyledHeader = styled(Typography)`
  text-transform: uppercase;
  font-size: 1.6923rem;
  font-weight: 400;
  line-height: 1.5385rem;
  letter-spacing: 0.0385rem;
  text-align: center;
`;

export const StyledLogo = styled.img`
  transform: translateY(0.1rem);
  margin: 0 0.3rem;
`;

export const StyledInfo = styled.div`
  padding: 2rem 5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  > p {
    margin: 0;
    font-size: 1.0769rem;
    font-weight: 400;
    line-height: 1.6154rem;
    letter-spacing: 0.0154rem;
    text-align: left;

    > strong {
      font-weight: 700;
    }
  }
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  align-items: center;

  > p {
    margin: 0;
    padding: 0;
  }
`;

const StyledBaseMessage = styled.h5`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  text-transform: uppercase;
  text-align: center;
  font-size: 1.2308rem;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 0.0154rem;
  margin: 0;
  padding: 0;
`;

export const StyledSuccessMessage = styled(StyledBaseMessage)`
  color: ${lightColorPalette.lbGreenDark};
`;

export const StyledErrorMessage = styled(StyledBaseMessage)`
  color: ${lightColorPalette.lbRedDark};
`;
